/**
 * TXC shipping estimate: upgrades the server-rendered "Shipping time
 * shown above; delivery varies by destination" line into a real calendar
 * date range, from the visitor's own local Date (never baked into cached
 * Liquid output).
 *
 * A custom element instead of an inline IIFE because a plain <script>
 * never re-runs once inserted via innerHTML/outerHTML (product-info.js's
 * handleUpdateProductInfo does a SELECTIVE update for an ordinary
 * same-product variant change — price/Sku/Inventory/Volume/Price-Per-
 * Item only; it does not replace the whole section — so it explicitly
 * swaps this block's own outerHTML via updateShippingEstimate, which is
 * why a plain script would never re-run). connectedCallback fires on
 * every real DOM insertion, including that swap, with no manual event
 * subscription (and so nothing to accidentally double-subscribe).
 */
if (!customElements.get('shipping-estimate-widget')) {
  customElements.define(
    'shipping-estimate-widget',
    class ShippingEstimateWidget extends HTMLElement {
      connectedCallback() {
        var deliveryLine = this.querySelector('[data-shipping-estimate-delivery-line]');
        if (!deliveryLine) return;

        function readDays(value, fallback, minimum) {
          var parsed = parseInt(value, 10);
          return Number.isFinite(parsed) && parsed >= minimum ? parsed : fallback;
        }
        var shipMin = readDays(this.getAttribute('data-ship-min'), 1, 0);
        var shipMax = readDays(this.getAttribute('data-ship-max'), 2, 0);
        var transitDays = readDays(this.getAttribute('data-transit-days'), 4, 1);

        function addBusinessDays(date, days) {
          var result = new Date(date.getTime());
          var added = 0;
          while (added < days) {
            result.setDate(result.getDate() + 1);
            var day = result.getDay();
            if (day !== 0 && day !== 6) added++;
          }
          return result;
        }

        function formatDate(date) {
          return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        }

        function formatRange(startDate, endDate) {
          if (startDate.getTime() === endDate.getTime()) return formatDate(startDate);
          var sameMonth =
            startDate.getMonth() === endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear();
          if (sameMonth) return formatDate(startDate) + '–' + endDate.getDate();
          return formatDate(startDate) + '–' + formatDate(endDate);
        }

        var today = new Date();
        today.setHours(0, 0, 0, 0);

        var shipStart = addBusinessDays(today, shipMin);
        var shipEnd = addBusinessDays(today, shipMax);

        var deliveryStart = new Date(shipStart.getTime());
        deliveryStart.setDate(deliveryStart.getDate() + transitDays);
        var deliveryEnd = new Date(shipEnd.getTime());
        deliveryEnd.setDate(deliveryEnd.getDate() + transitDays);

        deliveryLine.textContent = 'Estimated delivery: ' + formatRange(deliveryStart, deliveryEnd);
      }
    }
  );
}
